const base_url = 'https://dudao.tianwangwatch.cn';
// 初始化用户资料
const InitUserData_api = '/twb_api/user/initInfo';

// 完善个人资料
const CompleteInfo_api = '/twb_api/user/perfectInfo'

// 积分排名弹窗
const IntegralRanking_api = '/twb_api/course/integralRanking'

// 获取课程列表
const GetCourseList_api = '/twb_api/course/getCourseList'

// 获取课程详情
const GetCourseInfo_api = '/twb_api/course/getCourseDetail'

// 切换视频的清晰度
const ChangeVideoArticulation_api = '/twb_api/qiniu/transcoding'

// 获取专题考试题目类型
const GetThematicType_api = '/twb_api/exam/getSubjectType'

// 获取管理公告列表
const GetManageList_api = '/twb_api/manage/getManageList'

// 获取管理公告详情
const GetManageDetail_api = '/twb_api/manage/getManageDetail'

// 获取专题练习题目列表
const GetSubjectList_api = '/twb_api/exam/getSubjectList'

// 错题入错题集
const PostErrorSubject_api = '/twb_api/exam/saveErrorSubject'

// 错题出错题集
const ErrorSubOutList_api = '/twb_api/exam/delErrorSubject'

// 获取错题集类型列表
const GetErrorSubjectTypeList_api = '/twb_api/exam/getErrorSubjectTypeList'

// 获取错题考卷试题
const GetErrorSubjectList_api = '/twb_api/exam/getErrorSubjectList'

// 获取年度考试试卷
const GetNdExam_api = '/twb_api/exam/createNdExam'

// 提交年度考试试卷
const PostCommitNdExam_api = '/twb_api/exam/commitNdExam'

// 获取综合考试试卷
const GetZhExam_api = '/twb_api/exam/createZhExam'

// 提交综合考试试卷
const PostCommitZhExam_api = '/twb_api/exam/commitZhExam'

// 上传头像
const UploadFile_api = '/twb_api/user/uploadImg'

// 保存用户修改资料信息
const SaveUserInfo_api = '/twb_api/user/perfectInfo'

// 个人中心(我的课程)
const GetMyCourseList_api = '/twb_api/user/myReadCourse'

// 个人中心(我的考核)
const GetMyExamList_api = '/twb_api/user/myExam'

// 个人中心(我的考核明细)
const GetExamDetail_api = '/twb_api/exam/getExamDetail'

// 个人中心(我的积分)
const GetMyIntegralList_api = '/twb_api/user/myIntegral'

// 个人中心(排行榜)
const GetIntegralRanking_api = '/twb_api/ranking/integralRanking'

// 获取积分说明及获取使用说明
const GetInstructions_api = '/twb_api/user/instructions'

// 获取考核完成时的表情设置
const GetFaceScore_api = '/twb_api/exam/faceScore'

// 获取在线时长
const GetOnlineTime_api = '/twb_api/auth/recordTimeLen'

// 更新用户信息
const UpdataUserInfo_api = '/twb_api/auth/updateUserInfo'

// 记录专题练习记录
const PostExercise_api = '/twb_api/exam/saveSubjectRecord'

// 记录板跳转题目,且中间还有没有答题的答题记录(专题练习)
const SaveSubjectRecordByChoose_api = '/twb_api/exam/saveSubjectRecordByChoose'

// 获取排行榜设置
const GetRankSetting_api = '/twb_api/ranking/getRankSetting'

// 记录专题答题次数
const SaveSubjectSubmitCount_api = '/twb_api/exam/saveSubjectSubmitCount'

export default {
    base_url, // 请求地址
    InitUserData_api, // 初始化用户资料
    CompleteInfo_api, // 完善个人资料
    IntegralRanking_api,// 积分排名弹窗
    GetCourseList_api, // 获取课程列表
    GetCourseInfo_api, // 获取课程详情
    ChangeVideoArticulation_api, // 切换视频清晰度
    GetThematicType_api, // 获取专题考试题目类型
    GetManageList_api, // 获取管理公告列表
    GetManageDetail_api, // 获取管理公告详情
    GetSubjectList_api, // 获取专题练习题目列表
    GetErrorSubjectTypeList_api, // 获取错题集类型列表
    GetErrorSubjectList_api, // 获取错题考卷试题
    PostErrorSubject_api, // 错题入错题集
    ErrorSubOutList_api, // 错题出错题集
    GetNdExam_api, // 获取年度考试试卷
    PostCommitNdExam_api, // 提交年度考试试卷
    GetZhExam_api, // 获取综合考试试卷
    PostCommitZhExam_api, // 提交综合考试
    UploadFile_api, // 上传头像
    SaveUserInfo_api, // 保存用户修改资料信息
    GetMyCourseList_api, // 个人中心(我的课程)
    GetMyExamList_api, // 个人中心(我的考核)
    GetExamDetail_api, // 个人中心(我的考核明细)
    GetMyIntegralList_api, // 个人中心(我的积分)
    GetIntegralRanking_api, //个人中心(排行榜)
    GetInstructions_api, // 获取积分说明及使用说明
    GetFaceScore_api, // 获取表情类型
    GetOnlineTime_api, // 获取在线时长
    UpdataUserInfo_api, // 更新用户信息
    PostExercise_api, // 记录专题练习记录
    SaveSubjectRecordByChoose_api, // 记录板跳转题目,且中间还有没有答题的答题记录(专题练习)
    GetRankSetting_api, //获取排行榜设置
    SaveSubjectSubmitCount_api, // 记录专题练习次数
}


// WEBPACK FOOTER //
// ./src/api/index.js